import { render } from "./Capture.vue?vue&type=template&id=e3c49012"
import script from "./Capture.vue?vue&type=script&lang=js"
export * from "./Capture.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__